import { Location } from 'history'
import React, { useCallback, useContext, useMemo, useRef } from 'react'
import { useHistory, useLocation } from 'react-router'

const PAGINAS_ERRO = ['/403', '/404']

interface NavegacaoHistoricoModel {
  getPaginaAnterior(): Location | undefined
}

interface NavegacaoHistoricoProviderProps {
  children: React.ReactNode
}

const NavegacaoHistoricoContext = React.createContext<NavegacaoHistoricoModel>({
  getPaginaAnterior: () => undefined,
})

export function NavegacaoHistoricoProvider(props: Readonly<NavegacaoHistoricoProviderProps>) {
  const { children } = props

  const history = useHistory()
  const location = useLocation()
  const anterior = useRef<Location>()
  const atual = useRef<Location>()

  if (atual.current !== location) {
    if (history.action !== 'REPLACE' && atual.current && !isPaginaErro(atual.current.pathname)) {
      anterior.current = atual.current
    }
    atual.current = location
  }

  const getPaginaAnterior = useCallback(() => anterior.current, [])

  const value = useMemo(() => ({ getPaginaAnterior }), [getPaginaAnterior])

  return <NavegacaoHistoricoContext.Provider value={value}>{children}</NavegacaoHistoricoContext.Provider>
}

export const useVoltarPaginaAnterior = () => {
  const history = useHistory()
  const { getPaginaAnterior } = useContext(NavegacaoHistoricoContext)

  return useCallback(() => history.replace(getPaginaAnterior() ?? '/'), [getPaginaAnterior, history])
}

const isPaginaErro = (pathname: string) => PAGINAS_ERRO.includes(pathname)
